"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const FieldControls_1 = __importDefault(require("../controls/FieldControls"));
const NestedHobbyInput_1 = __importDefault(require("../inputs/NestedHobbyInput"));
exports.default = (0, mobx_react_1.observer)(({ hobbies }) => (react_1.default.createElement("fieldset", { className: 'pa3' },
    react_1.default.createElement("div", { className: "cf" },
        react_1.default.createElement("h5", { className: "fl mv0" }, [
            hobbies.container().$('firstname').value,
            hobbies.container().$('lastname').value,
            hobbies.label,
        ].join(' ')),
        react_1.default.createElement("div", { className: "fr" },
            react_1.default.createElement(FieldControls_1.default, { field: hobbies, 
                // labels={false}
                controls: {
                    onAdd: true,
                } }))),
    hobbies.map(hobby => react_1.default.createElement(NestedHobbyInput_1.default, { field: hobby, key: hobby.key })))));
